import styled, { css } from 'styled-components'
import { resources } from './resources'

const designerCSS = css`
  /* ================== GLOBAL DEFAULTS ================== */

  html summary::-webkit-details-marker {
    display: none;
  }
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-family: 'Inter', sans-serif;
    padding: 0;
    margin: 0;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* font-smoothing: antialiased; */
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    font-feature-settings: 'kern';
    shape-rendering: geometricPrecision;
    direction: ltr;
    line-height: 100%;
    font-weight: 400;
    color: #fff;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }
  ul,
  ol,
  li {
    list-style: none;
  }
  body,
  html {
    height: 100%;
  }
  &#body {
    font-size: 13px;
    color: #fff;
    animation: bugfix infinite 1s;
    -webkit-animation: bugfix infinite 1s;
    background: rgb(20, 24, 33);
    background: hsl(222, 17%, 10%);
    background: url(${resources.yolobot_bg_4}) center -100px / 3700px 2775px no-repeat;
    min-width: 375px;
  }
  fieldset {
    outline: 0;
    border: 0;
  }
  a {
    color: #fff;
    text-decoration: none;
    text-decoration-color: rgba(255, 255, 255, 0.4);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }
  a:hover {
    text-decoration: none;
  }
  input[type='text'] {
    border: 0;
    outline: 0;
  }
  button {
    outline: none;
    border: none;
    background: hsla(0, 0%, 100%, 0.2);
    background: linear-gradient(
      180deg,
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 96%, 0.2),
      hsla(0, 0%, 91%, 0.2),
      hsla(0, 0%, 87%, 0.2),
      hsla(0, 0%, 83%, 0.2),
      hsla(0, 0%, 79%, 0.2),
      hsla(0, 0%, 75%, 0.2),
      hsla(0, 0%, 71%, 0.2)
    );
    -webkit-backdrop-filter: blur(20px);
    /* border: 1px solid hsla(68,100%,50%,.5); */
    backdrop-filter: blur(20px);
    text-decoration: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 100%;
    border-radius: 20px;
    padding: 16px 30px 15px 30px;
    font-size: 1.2rem;
    color: #deff00;
    text-transform: uppercase;
    letter-spacing: -0.02em;
    margin: 20px 0 0 0;
  }
  button strong {
    color: #deff00;
    font-weight: 700;
    padding: 0 0 0 30px;
    margin: 0 0 0 10px;
    background: url(${resources.telegram_logo}) left center / 22px auto no-repeat;
  }
  button:hover {
    background: linear-gradient(
      180deg,
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2)
    );
  }
  button[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* SCROLLBARS */

  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:vertical,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: hsla(0, 0%, 100%, 0.15);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
  @-moz-document url-prefix() {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:vertical,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: hsla(0, 0%, 100%, 0.15);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }

  .yolorekt_logo-stacked {
    -webkit-mask: url(${resources.yolorekt_logo_stacked_SOLID_FFFFFF}) center center / 150px auto no-repeat;
    mask: url(${resources.yolorekt_logo_stacked_SOLID_FFFFFF}) center center / 150px auto no-repeat;
    background: #29416f;
    width: 215px;
    height: 78px;
    display: flex;
    margin: 0 0 10px 0;
  }
  .yolorekt_logo-stacked:hover {
    background: #2159d1;
  }
  .yolobot_logo {
    background: url(${resources.yolobot_logo_2}) center center / 360px auto no-repeat;
    width: 360px;
    height: 94px;
    display: flex;
  }

  #page_wrapper {
    overflow: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  #main {
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 1 auto;
    z-index: 2;
    overflow-y: hidden;
  }
  .content {
    height: 100%;
    transition: width 300ms ease-in-out;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    padding: 30px;
  }
  .project_description {
    font-size: 0.85rem;
    opacity: 0.5;
    padding: 135px 0 20px 0;
    text-align: center;
    line-height: 130%;
  }
  .project_description strong {
    font-weight: 800;
  }
  .project_tagline {
    font-size: 1.3rem;
    font-weight: 500;
    line-height: 140%;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .view_docs {
    font-size: 0.9rem;
    margin: 25px 0 0 0;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .view_docs strong {
    font-weight: 600;
    display: block;
    text-transform: uppercase;
    margin: 0 0 5px 0;
  }
  .view_docs a {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.6);
  }

  /* ================== FOOTER ================== */

  footer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 0.75rem;
    padding: 30px 0;
    margin: 30px 0 0 0;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 11;
    width: 90%;
    flex-wrap: nowrap;
    color: #152d4f;
  }
  footer #landing-details {
    display: flex;
    flex-direction: row;
    min-width: auto;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  footer .about {
    width: 100%;
    max-width: 600px;
    text-align: center;
    line-height: 135%;
    font-size: 0.75rem;
    color: #152d4f;
  }
  footer .about div {
    display: block;
    margin: 10px 0 0 0;
    color: #152d4f;
  }
  footer .about a {
    font-weight: 600;
    border-bottom: 1px dotted hsla(215, 58%, 20%, 0.6);
  }
  footer .about a:hover {
    border-bottom: 1px dotted hsla(215, 58%, 20%, 0.9);
  }
  footer a {
    color: #152d4f;
  }
  footer a:hover {
    border-bottom: 1px dotted hsla(215, 58%, 20%, 0.9);
  }
  footer #copyright,
  footer #priv-terms {
    white-space: nowrap;
    font-size: 0.75rem;
    color: #152d4f;
    margin-bottom: 5px;
  }
  footer #copyright a,
  footer #priv-terms a {
    font-weight: 600;
    border-bottom: 1px dotted hsla(215, 58%, 20%, 0.6);
  }
  footer #copyright {
    padding: 5px 15px;
  }
  footer #copyright strong {
    color: #152d4f;
  }
  footer #landing-social {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 15px 0 0 0;
  }
  footer #landing-social a.icon {
    background-color: hsl(215, 58%, 20%);
    -webkit-mask-position: center center;
    mask-position: center center;
    margin: 0 0 0 15px;
    display: block;
  }
  footer #landing-social a.twitter {
    -webkit-mask: url(${resources.twitter_icon}) no-repeat;
    mask: url(${resources.twitter_icon}) no-repeat;
    -webkit-mask-size: auto 20px;
    mask-size: auto 20px;
    width: 24px;
    height: 22px;
  }
  footer #landing-social a.tiktok {
    -webkit-mask: url(${resources.tiktok_icon}) no-repeat;
    mask: url(${resources.tiktok_icon}) no-repeat;
    -webkit-mask-size: auto 20px;
    mask-size: auto 20px;
    width: 24px;
    height: 22px;
  }
  footer #landing-social a.medium {
    -webkit-mask: url(${resources.medium_icon}) no-repeat;
    mask: url(${resources.medium_icon}) no-repeat;
    -webkit-mask-size: auto 18px;
    mask-size: auto 18px;
    width: 22px;
    height: 18px;
  }
  footer #landing-social a.telegram {
    -webkit-mask: url(${resources.telegram_icon}) no-repeat;
    mask: url(${resources.telegram_icon}) no-repeat;
    -webkit-mask-size: auto 20px;
    mask-size: auto 20px;
    width: 23px;
    height: 20px;
  }
  footer #landing-social a.discord {
    -webkit-mask: url(${resources.discord_icon}) no-repeat;
    mask: url(${resources.discord_icon}) no-repeat;
    -webkit-mask-size: auto 20px;
    mask-size: auto 20px;
    width: 26px;
    height: 20px;
  }
  footer #landing-social a.email {
    -webkit-mask: url(${resources.email_icon}) no-repeat;
    mask: url(${resources.email_icon}) no-repeat;
    -webkit-mask-size: auto 22px;
    mask-size: auto 22px;
    width: 32px;
    height: 22px;
  }
  footer #landing-social a.icon:hover {
    background-color: #2e68eb;
  }

  @media (max-height: 800px) {
    button {
      margin: 0;
    }
    .project_description {
      padding: 95px 0 20px 0;
    }
    .yolorekt_logo-stacked {
      -webkit-mask-size: 100px auto;
      mask-size: 100px auto;
      width: 100px;
      height: 52px;
      background: #fff;
      bottom: 125px;
    }
    footer {
      color: #fff;
      padding-bottom: 20px;
    }
    footer .about {
      color: #fff;
      font-size: 0.7rem;
    }
    footer .about div {
      color: #fff;
      margin: 5px 0 0 0;
    }
    footer .about a {
      border-bottom: 1px dotted hsla(0, 0%, 100%, 0.6);
    }
    footer .about a:hover {
      border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
    }
    footer #copyright,
    footer #priv-terms {
      color: #fff;
    }
    footer #copyright a,
    footer #priv-terms a {
      font-weight: 600;
      border-bottom: 1px dotted hsla(0, 0%, 100%, 0.6);
    }
    footer a:hover {
      border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
    }
    footer #copyright strong {
      color: #fff;
    }
    footer a {
      color: rgba(255, 255, 255, 1);
    }
    footer #landing-social {
      padding: 10px 0 0 0;
    }
    footer #landing-social a.icon {
      background-color: hsl(0, 0%, 100%);
    }
  }

  @media (max-width: 640px) and (max-height: 800px) {
    body {
      background-size: 3500px 2625px;
    }
    .project_description {
      padding: 65px 0 10px 0;
      font-size: 0.8rem;
    }
    .yolobot_logo {
      background-size: 260px auto;
      width: 260px;
      height: 68px;
    }
    .project_tagline {
      font-size: 1.1rem;
    }
    .yolorekt_logo-stacked {
      bottom: 185px;
    }
    footer {
      padding-bottom: 50px;
    }
  }

  @media (max-width: 400px) and (max-height: 800px) {
    button {
      font-size: 1.1rem;
    }
    .view_docs {
      font-size: 0.8rem;
    }
  }
`

const developerCSS = css`
  a#bot-button {
    outline: none;
    border: none;
    background: hsla(0, 0%, 100%, 0.2);
    background: linear-gradient(
      180deg,
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 96%, 0.2),
      hsla(0, 0%, 91%, 0.2),
      hsla(0, 0%, 87%, 0.2),
      hsla(0, 0%, 83%, 0.2),
      hsla(0, 0%, 79%, 0.2),
      hsla(0, 0%, 75%, 0.2),
      hsla(0, 0%, 71%, 0.2)
    );
    -webkit-backdrop-filter: blur(20px);
    /* border: 1px solid hsla(68,100%,50%,.5); */
    backdrop-filter: blur(20px);
    text-decoration: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 100%;
    border-radius: 20px;
    padding: 16px 30px 15px 30px;
    font-size: 1.2rem;
    color: #deff00;
    text-transform: uppercase;
    letter-spacing: -0.02em;
    margin: 20px 0 0 0;
  }
  a#bot-button strong {
    color: #deff00;
    font-weight: 700;
    padding: 0 0 0 30px;
    margin: 0 0 0 10px;
    background: url(${resources.telegram_logo}) left center / 22px auto no-repeat;
  }
  a#bot-button:hover {
    background: linear-gradient(
      180deg,
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0.2)
    );
  }
`

export const YoloBotCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
